import { createStore } from 'vuex'
import router  from '../router'
import { doc, getDoc, getDocsFromServer} from 'firebase/firestore'
import { collection, getDocs, query, where, limit, updateDoc } from 'firebase/firestore'
import db from '../firebase/firebaseInit.js'
import { ref} from "@firebase/storage";
import storage from "@/firebase/firebaseInit.js";
import  { auth }  from '../firebase/firebaseInit'
// import { getAuth, fetchSignInMethodsForEmail, EmailAuthProvider} from "firebase/auth";
import { signInWithEmailAndPassword, signOut, onAuthStateChanged } from 'firebase/auth'

const store = createStore({
  state: {
    // user
    user: null,
    authIsReady: false,
    profileLoaded: null,
    // AVERT MANAGEMENT
    AADDate: [],
    AADloaded: null,
    AD_SlotID: null,
    AD_Text: null,
    ALDDate: [],
    ALDloaded: null,
    // advert
    Ads_SlotID: null,
    Advert_Data: false,
    // sitemode
    NAV: null,
    // STARSytems
    TicketsData: [],
    TicketData: [],
    TicketsLoaded: null, 
    // end STARS
  },
  getters: {
  },
  mutations: {
    // user
    setUser(state, payload) {
      state.user = payload
    },
    setAuthIsReady(state, payload) {
      state.authIsReady = payload
    },  
    updateUser(state, payload) {
      state.user = payload;
    },
    // end of user
    // set advert data
    setAdvertSlot(state, doc) {
      // live setAdvert
      state.Ad_ID = doc.id
      // state.AD_Title = doc.data().AD_Title
      state.AD_Text = doc.data().AD_Text
      state.AD_Link = doc.data().AD_Link
      state.AD_Link_Text = doc.data().AD_Link_Text
      state.AD_Images = doc.data().AD_Images
      state.AD_SlotID = doc.data().AD_SlotID
      state.Advert_Data = true
      console.log("Slot set:", state.AD_Text, state.AD_Link, state.AD_Link_Text, state.AD_Images, state.AD_SlotID)
    },
    // set max 
    setMaxSlot(state, doc) {
      state.slot_max = doc.data().slot_max
      console.log(" ")
    },
    // Admin advert
    AAD(state, payload) {
      state.AADDate.push(payload);
    },
    AADloaded(state) {
      state.AADloaded = true
    },
    // ALD(state, payload) {
    //   state.ALDDate.push(payload);
    // },
    // ALDloaded(state) {
    //   state.ALDloaded = true
    // },

    // STARSytems
    SetTicketData(state, payload) {
      state.TicketsData.push(payload);
    },
    SetTicket(state) {
      state.TicketsLoaded = true
    },
    
  },
  actions: {
    async login(context, { email, password }) {
      const res = await signInWithEmailAndPassword(auth, email, password)
      if (res) {
        context.commit('setUser', res.user)
      } else {
        throw new Error('could not complete login')
      }
    },
    async logout(context) {
      await signOut(auth)
      context.commit('setUser', null)
      window.location = "/"
    },
    fetchUser ({ commit }) {
      var currentUrl = window.location.pathname;
      auth.onAuthStateChanged(async user => {
        if (user === null){
          return
        } else {
          commit('setUser', user)
          const useruid = user.uid
          // const docRef = doc(db, "user", useruid);
          // const docSnap = await getDoc(docRef);
          // commit("setProfileInfo", docSnap);
          // commit("setProfileInitials");
          // commit("profileLoaded")
          
          
          if(router.isReady() && router.currentRoute.value.path === '/auth') {
            router.push(currentUrl)
          }
        }
      })
    },
    // async fetchData ({state, commit}) {
    //   const sitemode = "Net";
    //   console.log(sitemode)
    //   const docRef = doc(db, "Ads-Account", sitemode);
    //   const docSnap = await getDoc(docRef);  
    //   console.log(docSnap.data())
    //   commit("setContent", docSnap);
    // },
    // Set Advert
    async fetchAdvertSlot ({state, commit}) {
      function getRandomInt(max) {
        return Math.floor(Math.random() * max);
      }
      const Adscall = '2'
      // getRandomInt(3).toString();
      console.log(Adscall)
      const getData = doc(db,"Ads", Adscall);
      const docSnap = await getDoc(getData);  
      console.log(docSnap.data())
      commit("setAdvertSlot", docSnap);

    },
    // Advert management
    async AdminAdvertData ({state, commit}) {
      const getData = query(collection(db,"Ads"), where("AD_SlotID", "!=", "Deleted" ));
      const results = await getDocs(getData);
      results.forEach(doc => {
        if (!state.AADDate.some((Advert) => Advert.docId === doc.id)) {
          const data = {
            docId: doc.id,
            AD_SetID: doc.data().AD_SetID,
            AD_Title: doc.data().AD_Title,
            AD_SlotID: doc.data().AD_SlotID,
            AD_Text: doc.data().AD_Text,
            AD_Link: doc.data().AD_Link,
            AD_Link_Text: doc.data().AD_Link_Text,
            AD_Images: doc.data().AD_Images,
            AD_SlotID: doc.data().AD_SlotID,
          };
        commit("AAD", data);
      }
      commit('AADloaded')
      });
      const getslotid = doc(db,"Ads", "ads_slot_max")
      const result_slotid = await getDoc(getslotid);
      commit("setMaxSlot", result_slotid);
    },
    // STARStyems
  },
  modules: {
  }
})

const unsub = onAuthStateChanged(auth, (user) => {
  store.commit('setAuthIsReady', true)
  store.commit('setUser', user)
  unsub()
})

// export the store
export default store
